import { ExpressionValue } from "../../ExpressionValue";
import { BaseStringExpression } from "./BaseString";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringTrimExpression extends BaseStringExpression {
    readonly __type: string = "String Trim";
    readonly __ruleName: string = "Trim";
    value1: ExpressionValue;

    constructor() {
        super();

        this.value1 = ExpressionValue.createExpressionValue(this, "stringValue", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).trim();
    }
}
